import React, { Component, PropTypes } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import { Tabs, Tab } from 'material-ui/Tabs';
import Paper from 'material-ui/Paper';
import CircularProgress from 'material-ui/CircularProgress';
import RefreshIndicator from 'material-ui/RefreshIndicator';

import ActivityList from './activity-list.jsx';

const styles = {
  content: {
    margin: '1em',
    padding: '1em',
    borderRadius: '10px !important',
    '&.loading': {
      opacity: '0.7',
    },
  },
  tabs: {
    '&>div:first-of-type': {
      backgroundColor: 'transparent !important',
    },
    '&>div:nth-of-type(2)': {
      borderBottom: '0.1em solid #3e5a6d !important',
    },
  },
  tab: {
    textTransform: 'none !important',
    color: '#90a4ae !important',
    fontSize: '1.3em !important',
    '&.active': {
      color: '#3e5a6d !important',
    },
  },
  tabContent: {
    marginTop: '3em',
    '@media (min-width: 1000px)': {
      '&:before': {
        background: '#90a4ae',
        content: "''",
        display: 'block',
        height: '100%',
        left: '40px',
        position: 'absolute',
        top: '10px',
        width: '1px',
        zIndex: 0,
      },
    },
  },
  inkBarStyle: {
    background: '#3e5a6d',
    height: '0.4em',
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
    paddingBottom: '1em',
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};

class Activities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '',
      width: null,
    };
  }
  componentWillMount() {
  }
  componentDidMount() {
    this.handleActive({ props: { filter: 'all' } });
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }
  handleActive = (tab) => {
    const { props: { filter } } = tab;
    this.setState({
      activeTab: filter,
    });
  }
  updateDimensions = () => {
    const findDom = (document.getElementsByClassName(this.props.classes.tabs) || [null])[0];
    if (findDom && findDom.clientWidth) {
      const width = findDom.clientWidth;
      this.setState({ width });
    }
  }
  render() {
    const { classes, activitiesLoaded, activitiesLoading, activities: allActivities } = this.props;
    const { activeTab, width } = this.state;
    const activities = [...(() => {
      switch (activeTab) {
        case 'notes':
          return allActivities.filter(e => e.type === 'note');
        case 'contracting':
          return allActivities.filter(e => Boolean(e.contracts && e.contracts.length));
        case 'messages':
          return allActivities.filter(e => e.type !== 'note' && Boolean(e.bodyText));
        default:
          return allActivities;
      }
    })()];
    if (activitiesLoaded) {
      return (
        <Paper className={`${classes.content}${activitiesLoading ? ' loading' : '' }`}>
          <Tabs
            className={classes.tabs}
            inkBarStyle={styles.inkBarStyle}
          >
          {[
            <Tab
              label="All Activities"
              filter="all"
              key="all"
              onActive={this.handleActive}
              className={`${classes.tab}${activeTab === 'all' ? ' active' : ''}`}
            >
              <ActivityList className={classes.tabContent} activities={activities} />
            </Tab>,
            <Tab
              label="Contracting"
              filter="contracting"
              key="contracting"
              onActive={this.handleActive}
              className={`${classes.tab}${activeTab === 'contracting' ? ' active' : ''}`}
            >
              <ActivityList className={classes.tabContent} activities={activities} />
            </Tab>,
            <Tab
              label="Messages"
              filter="messages"
              key="messages"
              onActive={this.handleActive}
              className={`${classes.tab}${activeTab === 'messages' ? ' active' : ''}`}
            >
              <ActivityList className={classes.tabContent} activities={activities} />
            </Tab>,
            <Tab
              label="Internal Notes"
              filter="notes"
              key="notes"
              onActive={this.handleActive}
              className={`${classes.tab}${activeTab === 'notes' ? ' active' : ''}`}
            >
              <ActivityList className={classes.tabContent} activities={activities} />
            </Tab>,
            ...(width > 650) ? [
              <Tab
                label=""
                key="spacer1"
                disabled
                className={classes.tab}
              />,
            ] : [],
            ...(width > 800) ? [
              <Tab
                label=""
                key="spacer2"
                disabled
                className={classes.tab}
              />,
            ] : [],
          ].map(e => e)}
          </Tabs>
        </Paper>
      );
    }
    if (activitiesLoading) {
      return (
        <Paper className={classes.content}>
          <div className={classes.loading}>
            <CircularProgress />
          </div>
        </Paper>
      );
    }
    return (
      <Paper className={classes.content}>
        <div className={classes.loading}>
          <RefreshIndicator
            percentage={80}
            size={60}
            left={0}
            top={0}
            color="red"
            status="ready"
            style={styles.refresh}
          />
        </div>
      </Paper>
    );
  }
}

Activities.propTypes = {
  activities: PropTypes.array,
  activitiesLoaded: PropTypes.bool,
  activitiesLoading: PropTypes.bool,
  classes: PropTypes.object,
};

const select = ({ partnerDetails: store }) => ({
  activities: store.activities,
  activitiesLoaded: store.activitiesLoaded,
  activitiesLoading: store.activitiesLoading,
});

export default connect(select, {})(injectSheet(styles)(Activities));



// WEBPACK FOOTER //
// ./src/app/components/partner-details/activities/index.jsx